document.addEventListener('DOMContentLoaded', function () {
  Fancybox.bind('[data-fancybox]', {
    on: {
      'Carousel.ready Carousel.change': () => {
        const slide = Fancybox.getSlide();
        console.log(`Current slide index: #${slide.index}`);
        console.log(`Slide element:`);
        console.log(slide.el);
        console.log(`Corresponding trigger element:`);
        console.log(slide.triggerEl);

        if (slide.index === 0) {
          slide.el.querySelector('.fancybox__content').style.background = 'var(--product-card-background)';
        }
      },
    },
  });
});
